
/* Deux roles, en mobile seulement :
   - remplacer l'icone du panier par le pochon (toutes les pages) ;
   - sur les pages CLAIRES, reecrire en ligne l'encre du logo et de chaque
     trait des icones, parce que le theme ecrit ses couleurs en ligne avec
     !important. L'accueil n'est jamais touche. */
(function () {
  var ENCRE = '#14110F';
  var ICONES = ['#mzBurger svg', '#mzSearchBtnMobile svg', '.mz-actions .mz-action svg'];
  var POCHON = '<path d="M4.5 9h15l-1.2 11H5.7L4.5 9Z"/>'
             + '<path d="M4.5 9 7 4.2h10L19.5 9"/>'
             + '<path d="M9.4 12.4h5.2"/>';
  var enAttente = false;
  var enEcriture = false;

  function mobile() { return window.innerWidth <= 1000.9; }

  function pochon(h) {
    var svg = h.querySelector('.mz-action--cart svg');
    if (!svg || svg.getAttribute('data-alm-panier') === 'pochon') { return; }
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('stroke-width', '1.4');
    svg.setAttribute('stroke-linecap', 'round');
    svg.setAttribute('stroke-linejoin', 'round');
    svg.innerHTML = POCHON;
    svg.setAttribute('data-alm-panier', 'pochon');
  }

  function encrer(el) {
    if (el.style.getPropertyValue('color').toUpperCase() !== ENCRE) {
      el.style.setProperty('color', ENCRE, 'important');
    }
    if (el.style.getPropertyValue('stroke').toUpperCase() !== ENCRE) {
      el.style.setProperty('stroke', ENCRE, 'important');
    }
  }

  function traits(svg) {
    encrer(svg);
    var kids = svg.querySelectorAll('*');
    for (var i = 0; i < kids.length; i++) {
      var k = kids[i];
      var c = window.getComputedStyle(k);
      if (c.stroke && c.stroke !== 'none') {
        if (k.style.getPropertyValue('stroke').toUpperCase() !== ENCRE) {
          k.style.setProperty('stroke', ENCRE, 'important');
        }
      }
      if (c.fill && c.fill !== 'none' && c.fill !== 'rgba(0, 0, 0, 0)') {
        if (k.style.getPropertyValue('fill').toUpperCase() !== ENCRE) {
          k.style.setProperty('fill', ENCRE, 'important');
        }
      }
    }
  }

  function passe() {
    enAttente = false;
    var h = document.getElementById('mzHeader');
    if (!h) { return; }

    enEcriture = true;
    /* l'icone panier vaut pour mobile ET ordinateur */
    pochon(h);
    if (!mobile()) { enEcriture = false; return; }

    /* le compte reste sorti quoi qu'il arrive : le theme le rallume au
       defilement, ce qui faisait sauter la barre. */
    var compte = h.querySelector('.mz-actions .mz-action--account');
    if (compte && compte.style.getPropertyValue('display') !== 'none') {
      compte.style.setProperty('display', 'none', 'important');
    }

    if (h.classList.contains('mz-header--light-page')) {
      /* remontee complete quand le theme cache la barre : sa valeur d'origine
         (-66 px) laissait un bandeau visible et l'animation sautait. */
      if (h.classList.contains('mz-header--hidden')) {
        if (h.style.getPropertyValue('transform').indexOf('-101%') === -1) {
          h.style.setProperty('transform', 'translate3d(0, -101%, 0)', 'important');
        }
      } else if (h.style.getPropertyValue('transform')) {
        h.style.removeProperty('transform');
      }

      var logo = h.querySelector('.mz-logo-img');
      if (logo && logo.style.getPropertyValue('filter') !== 'brightness(0)') {
        logo.style.setProperty('filter', 'brightness(0)', 'important');
      }
      for (var i = 0; i < ICONES.length; i++) {
        var lot = h.querySelectorAll(ICONES[i]);
        for (var j = 0; j < lot.length; j++) { traits(lot[j]); }
      }
    }
    enEcriture = false;
  }

  function planifier() {
    if (enAttente) { return; }
    enAttente = true;
    if (window.requestAnimationFrame) { window.requestAnimationFrame(passe); }
    else { setTimeout(passe, 16); }
  }

  function surveiller() {
    var h = document.getElementById('mzHeader');
    if (!h || !window.MutationObserver) { return; }
    new MutationObserver(function () {
      if (enEcriture) { return; }
      planifier();
    }).observe(h, { attributes: true, childList: true, subtree: true, attributeFilter: ['style', 'class'] });
  }

  passe();
  surveiller();
  window.addEventListener('scroll', planifier, { passive: true });
  window.addEventListener('resize', planifier, { passive: true });
  document.addEventListener('DOMContentLoaded', function () { passe(); surveiller(); });
  window.addEventListener('load', function () { passe(); surveiller(); });
  setTimeout(passe, 600);
  setTimeout(passe, 1800);
})();
